import { Trophy, Plus, Copy } from '@phosphor-icons/react';
import { fmtDate as fmtDatePt } from '@/utils/dateFmt';

/**
 * View de lista (extraída de AdminDesafiosPage). Recebe handlers via props e mantém o
 * mesmo comportamento e data-testids para garantir zero regressões.
 */
export default function ChallengeListView({ challenges, loading, onSelect, onOpenCreate, onDuplicateFromList }) {
  return (
    <div className="fade-in" data-testid="desafios-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading font-medium text-2xl text-brand-text">Desafios</h2>
          <p className="text-sm text-brand-muted mt-1">Desafios de grupo para pacientes</p>
        </div>
        <button onClick={onOpenCreate} className="bg-brand-green text-white rounded-full px-4 py-2.5 text-sm font-medium flex items-center gap-2" data-testid="create-challenge-btn">
          <Plus size={16} /> Novo desafio
        </button>
      </div>

      {loading ? <div className="text-center py-12 text-brand-muted">A carregar...</div> : challenges.length === 0 ? (
        <div className="text-center py-16">
          <Trophy size={48} className="mx-auto text-brand-placeholder mb-4" weight="duotone" />
          <p className="text-brand-muted">Sem desafios criados.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {challenges.map(c => (
            <div key={c.id} className="bg-white border border-brand-border rounded-2xl p-4 hover:border-brand-green/30 transition-all">
              <div className="flex items-center justify-between">
                <button onClick={() => onSelect(c)} className="flex-1 text-left">
                  <h3 className="font-heading font-medium text-brand-text">{c.title}</h3>
                  <p className="text-xs text-brand-muted mt-0.5">{fmtDatePt(c.start_date)} → {fmtDatePt(c.end_date)}</p>
                  <p className="text-[10px] text-brand-placeholder mt-0.5" data-testid={`enrolled-count-${c.id}`}>{c.enrolled_count ?? 0} inscrito(s) · criado em {(c.created_at || '').slice(0, 10)}</p>
                </button>
                <div className="flex items-center gap-2">
                  <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full ${c.visibility === 'public' ? 'bg-blue-50 text-blue-600' : 'bg-brand-bg text-brand-muted'}`} data-testid={`visibility-badge-${c.id}`}>{c.visibility === 'public' ? 'Público' : 'Silencioso'}</span>
                  <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full ${c.active ? 'bg-brand-mint/20 text-brand-green' : 'bg-brand-bg text-brand-muted'}`}>{c.active ? 'Ativo' : 'Inativo'}</span>
                  <button onClick={(e) => { e.stopPropagation(); onDuplicateFromList(c); }} className="text-brand-placeholder hover:text-brand-green p-1" title="Duplicar" data-testid={`duplicate-list-${c.id}`}><Copy size={14} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
